module.exports = __webpack_public_path__ + "img/local_activity_opsz20.14e1fb33.svg";